module.exports = __webpack_public_path__ + "img/谢伟.5ae882c4.jpg";